import Joi from 'joi';

import {
  tenantContactCompanyNameRequired,
  tenantContactCreateIdRule,
  tenantContactWriteFields,
} from '../../../../shared/modules/contacts/validators/schemas/tenant-contact-write-fields.schema';

/**
 * Schema for contact validation belonging to a supplier.
 */
export const createSupplierContactSchema = () =>
  Joi.object({
    ...tenantContactCreateIdRule(),
    ...tenantContactCompanyNameRequired(),
    ...tenantContactWriteFields(),
  }).unknown();
